/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG, isNotEmpty } from '../../../../_metronic/helpers'
import './VisaListRecordCount.css'
import { object } from 'yup'
import { isEmpty } from 'lodash'



type Props = {
    className?: string
    heading?: string
    total_count?: string
    route_heading?: string
    data?: any
    name?: string
    count?: any
    emptycount?: any
    emptyarray?: any
    filter?: any
}

const VisaPointList: React.FC<Props> = ({ className, heading, count, data, emptycount, emptyarray, filter, name }) => {

    const convertEmptyArray = (emptyarray: any[]) => emptyarray.map(item => item.inq_id);

    function removeEmptyPairs(filter: any) {
        if (filter === undefined || filter === null) {
            return '';
        }
        const pairs = filter.split('&');
        // console.log('pair',pairs)
        const nonEmptyPairs = pairs.filter((pair: any) => {
            const [key, value] = pair.split('=');
            return value !== '';
        });
        // console.log('nonempty',nonEmptyPairs)
        const filteredFilter = nonEmptyPairs.join('&');

        return filteredFilter;
    }
    const filteredFilter = removeEmptyPairs(filter);

    const hasMatchingKey = filteredFilter.split('&').some((pair: any) => {
        const [key] = pair.split('=');
        return key === name;
    });
    let newFilteredFilter = filteredFilter;

    if (hasMatchingKey) {
        const pairs = newFilteredFilter.split('&');
        newFilteredFilter = pairs
            .filter((pair: any) => {
                const [key] = pair.split('=');
                return key !== name;
            })
            .join('&');
    }

    const currentPath = window.location.pathname + window.location.search;
    const updateURL = (paramName: any, paramValue: any) => {
        const currentPath = window.location.pathname + window.location.search;
        const newURL = window.location.search === ''
            ? `${currentPath}?${paramName}=${paramValue}`
            : `${currentPath}&${paramName}=${paramValue}`;
        window.open(newURL);
    };

    const handleItemClick = (e: any, obj: any) => {
        e.preventDefault();
        updateURL(name, obj?.[`id`]);
    };
    console.log('emptyarray', emptyarray)
    console.log('count', count)
    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{heading}</h3>
                <div className='card-toolbar'>
                    {(count || count == 0) && (<span className='fw-bold text-gray-800 badge badge-warning d-block me-2'>{count}</span>)}
                    {
                        emptyarray && (
                            <span className='fw-bold badge badge-danger d-block me-2'>{emptycount}</span>
                        )
                    }
                    {/* begin::Menu */}
                    {
                        ((emptyarray && emptyarray.length > 0) && (name === 'product_Id' || name === 'product_cate_Id' || name === 'visa_SalesExe_Id' || name === 'visa_FileExe_Id' || name === 'visa_VisaAssignBy_Id')) ? (
                            <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?emptyFilter=${convertEmptyArray(emptyarray)}`} target='_blank'>
                                <button
                                    type='button'
                                    className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                    data-kt-menu-trigger='click'
                                    data-kt-menu-placement='bottom-end'
                                    data-kt-menu-flip='top-end'
                                >
                                    <KTSVG path='/media/icons/duotune/arrows/arrow-up-right-square-fill.svg' className='svg-icon-2' />
                                </button>
                            </a>
                        ) : ((count > 0) && (name === 'visa_FileStage_Id' || name === 'visa_FileStatus_Id' || name === 'visa_Country_Id' || name === 'visa_point')) ? (
                            <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=yes`} target='_blank'>

                                <button
                                    type='button'
                                    className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                    data-kt-menu-trigger='click'
                                    data-kt-menu-placement='bottom-end'
                                    data-kt-menu-flip='top-end'
                                >
                                    <KTSVG path='/media/icons/duotune/arrows/arrow-up-right-square-fill.svg' className='svg-icon-2' />
                                </button>
                            </a>
                        ) : (
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                            >
                                <KTSVG path='/media/icons/duotune/arrows/arrow-up-right-square-fill.svg' className='svg-icon-2' />
                            </button>
                        )
                    }
                </div>
            </div>

            <div className='card-body pt-4 custom-fixed-height'>
                <div >
                    {data?.map((obj: any, index: any) =>
                        <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                            <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                            <div className='flex-grow-1 mx-8 '>

                                <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                    {obj?.[`name`]}
                                </a>
                            </div>
                            <span className='fw-bold badge badge-primary d-block me-2'>{obj?.[`count`]}</span>
                            {

                                <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/edit/${obj?.[`id`]}/applicant`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                    {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}
                                    <span className={`svg-icon svg-icon-2`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                            <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                        </svg>
                                    </span>
                                </a>
                                //     hasMatchingKey ?
                                // <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/edit?${newFilteredFilter}&${name}=${obj?.[`id`]}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                //     <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                // </a> :
                                // <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=${obj?.[`id`]}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                //     <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                // </a>
                            }

                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}

export { VisaPointList }
